import {
    FacebookConstants,
    LinkedInConstants,
    PinterestConstants,
    RedditConstants,
    TwitterConstants,
    KofiConstants,
    PatreonConstants,
    GoogleConstants,
    YoutubeConstants,
    DeveloperCompanyWebsiteConstants,
    ApplicationWebsiteConstants,
} from './website-constants-sites.classes';

export interface IWebsiteConstants {
    facebook: FacebookConstants;
    linkedIn: LinkedInConstants;
    pinterest: PinterestConstants;
    reddit: RedditConstants;
    twitter: TwitterConstants;

    //SupportSites
    kofi: KofiConstants;
    patreon: PatreonConstants;

    //Others
    google: GoogleConstants;
    youtube: YoutubeConstants;

    developerCompanyWebsite: DeveloperCompanyWebsiteConstants;
    applicationWebsite: ApplicationWebsiteConstants;

    getFullMainDomainUrl(type: string): string;
    getSupportUrl(type: string, userName: string): string;
    getShareUrl(type: string, data: IShareData): string;
}

export interface IDomainConstants {
    FULL_MAIN_DOMAIN_URL: string;
    MAIN_DOMAIN: string;
    NAME: string;
}

export interface IShareSite {
    getShareUrl(data: IShareData): string;
}

export interface ISupportSite {
    getSupportUrl(userName: string): string;
}

export interface IShareData {
    url: string;
    title: string;
}
